import * as React from "react";
const AvailableNotificationIcon = (props: any) => (
  <svg
    width={19}
    height={16}
    viewBox="0 0 19 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x={0.5} y={0.5} width={18} height={15} rx={7.5} fill="white" />
    <rect x={0.5} y={0.5} width={18} height={15} rx={7.5} stroke="#72BF44" />
    <path
      d="M13.125 10.3203C13.125 8 11.0655 8.51562 11.0655 6.71094C11.0655 6.56141 11.0511 6.43363 11.0249 6.3248C10.8895 5.41425 10.2835 4.6835 9.49822 4.46081C9.50519 4.42901 9.50884 4.3961 9.50884 4.36244C9.50884 4.09433 9.27715 3.875 8.99397 3.875C8.71079 3.875 8.4791 4.09433 8.4791 4.36243C8.4791 4.3961 8.48276 4.42901 8.48972 4.4608C7.60904 4.71054 6.95384 5.59919 6.93501 6.66382C6.93469 6.67929 6.93448 6.69495 6.93448 6.71092C6.93448 8.51562 4.875 8 4.875 10.3203C4.875 10.9344 6.24737 11.4482 8.08466 11.5778C8.25781 11.9033 8.59998 12.125 8.99397 12.125C9.38796 12.125 9.73014 11.9033 9.90328 11.5778C11.7406 11.4482 13.1129 10.9344 13.1129 10.3203C13.1129 10.3185 13.1127 10.3166 13.1127 10.3148L13.125 10.3203ZM11.522 10.7561C11.0858 10.8727 10.5715 10.9566 10.0195 11.0031C9.97362 10.476 9.53214 10.0625 8.99397 10.0625C8.4558 10.0625 8.01431 10.476 7.96842 11.0031C7.41648 10.9566 6.90218 10.8727 6.4659 10.7561C5.86551 10.5957 5.57847 10.4162 5.47342 10.3203C5.57847 10.2244 5.86551 10.0449 6.4659 9.88448C7.16397 9.69795 8.06178 9.59521 8.99397 9.59521C9.92616 9.59521 10.824 9.69795 11.522 9.88448C12.1224 10.0449 12.4095 10.2244 12.5145 10.3203C12.4095 10.4162 12.1224 10.5957 11.522 10.7561Z"
      fill="#72BF44"
    />
  </svg>
);
export default AvailableNotificationIcon;
